import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, IconButton } from '@material-ui/core';
import React from 'react';
import ExpressionComponent from '../ExpressionComponent/ExpressionComponent';
import { BlueBtn, RedInverseBtn } from '../Styled/StyledButtons';
import mainStyles from '../WorkerManagementComponent/WorkerManagementComponent.module.css';
import styles from './styles.module.css';
import ClearIcon from '@material-ui/icons/Clear';
import { Expression, IExpressionConfig, isAlwaysRule } from '../../models/ExpressionBuilder/ExpressionBuilderTypes';
import { ExpressionValidator } from '../../models/ExpressionBuilder/ExpressionValidator';
import { GUID } from '../../models/Guid';
import { HumanFriendlyExpressionConverter } from '../../models/ExpressionBuilder/HumanFriendlyExpressionConverter';
import { ExpressionJson } from '../../models/ExpressionBuilder/ExpressionJson';

const EMPTY_ERROR = 'Add a condition: "Always = yes" for skip_if 1==1, or a Worker counter condition'
const COMBINED_ERROR = '"Always" is a constant (1==1) and can`t be combined with other conditions'

export interface IProps {
    config: IExpressionConfig,
    defaultExpression: object,
    expression_json: string
    editShow: boolean
    toggleHandle: () => void
    saveHandle: (expressioon: string) => void
}

interface IState {
    expression_json: string,
    expression: string,
    workspaceSid: string,
    errors: string[]
}

export default class SkipTimeoutExpressionComponent extends React.Component<IProps, IState> {

    state: IState = {        
        expression_json: '',
        expression: '',
        workspaceSid: '',
        errors: []
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.props.expression_json !== prevProps.expression_json) {
            let expression = ExpressionJson.Parse(this.props.expression_json)
            this.setState({
                expression_json: this.props.expression_json,
                expression: (expression !== null && expression.rules.length > 0)
                    ? HumanFriendlyExpressionConverter.ConvertToTwilio(expression, 'workers', this.props.config)
                    : ''
            })
        }
    }

    handleExpression(exp: string) {
        let expression = ExpressionJson.Parse(exp)
        if (expression === null) {
            this.setState({ errors: [EMPTY_ERROR], expression_json: exp, expression: '' })
            return
        }
        this.setState({
            errors: this.validate(expression),
            expression_json: exp,
            expression: HumanFriendlyExpressionConverter.ConvertToTwilio(expression, 'workers', this.props.config)
        })
    }

    validate(expression: Expression): string[] {
        let errors: string[] = ExpressionValidator.Validate(expression)
        if (expression.rules.length === 0) {
            errors.push(EMPTY_ERROR)
        }
        if (expression.rules.length > 1 && (expression.rules as any[]).some((item: any) => isAlwaysRule(item))) {
            errors.push(COMBINED_ERROR)
        }
        return errors
    }

    save() {
        let expression = ExpressionJson.Parse(this.state.expression_json)
        if (expression === null) {
            this.setState({ errors: [EMPTY_ERROR] })
            return
        }
        let errors: string[] = this.validate(expression)
        this.setState({ errors: errors });
        if (errors.length === 0) {
            this.props.saveHandle(this.state.expression_json)
        }
    }

    render() {
        return (
            <div>
                <Dialog open={this.props.editShow} onClose={this.props.toggleHandle}>
                    <DialogTitle>
                        Skip Timeout
                        <IconButton className={mainStyles.floatRight} onClick={this.props.toggleHandle}>
                            <ClearIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                            <div className={`${styles.FormControl} ${styles.FullWidth}`}
                                 dangerouslySetInnerHTML={{ __html: this.state.expression }} />
                            </Grid>
                            <Grid item xs={12}>
                                <ul>
                                    {this.state.errors.map((error: string) => (
                                        <li className={styles.ExpressionError} key={GUID.New()}>{error}</li>
                                    ))}
                                </ul>
                            </Grid>
                            <Grid item xs={12}>
                                <ExpressionComponent dataOut={(expr: string) => this.handleExpression(expr)} data={this.state.expression_json || JSON.stringify(this.props.defaultExpression)} config={JSON.stringify(this.props.config)} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container spacing={1} >
                            <Grid item xs={6}  >
                                <RedInverseBtn fullWidth={true} onClick={this.props.toggleHandle}>Cancel</RedInverseBtn>
                            </Grid>
                            <Grid item xs={6}  >
                                <BlueBtn fullWidth={true} onClick={() => this.save()}>Save</BlueBtn>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
